/** Reveal an explicit action within the game's own scrolling panels, without moving the page or focus. */
export function revealControl(target: HTMLElement, boundary: HTMLElement, block: "nearest" | "start" = "nearest"): void {
  for (let panel = target.parentElement; panel && boundary.contains(panel); panel = panel.parentElement) {
    if (panel === document.body || panel === document.documentElement) break;
    const style = getComputedStyle(panel);
    const box = panel.getBoundingClientRect();
    const item = target.getBoundingClientRect();
    let top = panel.scrollTop, left = panel.scrollLeft;
    if (/(auto|scroll)/.test(style.overflowY) && panel.scrollHeight > panel.clientHeight) {
      if (block === "start") top += item.top - box.top;
      else if (item.top < box.top + 8) top += item.top - box.top - 8;
      else if (item.bottom > box.bottom - 8) top += item.bottom - box.bottom + 8;
    }
    if (/(auto|scroll)/.test(style.overflowX) && panel.scrollWidth > panel.clientWidth) {
      if (item.left < box.left) left += item.left - box.left;
      else if (item.right > box.right) left += item.right - box.right;
    }
    if (top !== panel.scrollTop || left !== panel.scrollLeft) panel.scrollTo({ top, left, behavior: "instant" });
    if (panel === boundary) break;
  }
}
